import React from "react";
import "./css/ButtonLanding.css";

import { Button } from "react-aria-components";
import useRenderIcon from "../../hooks/useRenderIcon";

import { LoadingSpinner2 } from "../Loaders";

function ButtonLanding(props) {
  const {
    iconStart,
    iconEnd,
    variant = 1,
    loading = false,
    className,
    disabled,
  } = props;

  const renderIcon = useRenderIcon();

  return (
    <Button
      {...props}
      onPress={props.onClick}
      className={`
        button-landing 
        variant-${variant} 
        ${loading && "loading"}
        ${className} 
      `}
      style={{ ...props.style }}
      isDisabled={loading || disabled}
    >
      {loading && (
        <LoadingSpinner2
          variant={1}
          size={1.25}
          color={variant == 1 ? "var(--neutral-50)" : "var(--neutral-450)"}
          thickness={0.125}
          style={{
            position: "absolute",
            inset: 0,
            margin: "auto",
          }}
        />
      )}
      {renderIcon(iconStart, "iconStart")}
      <span>{props.name}</span>
      {renderIcon(iconEnd, "iconEnd")}
    </Button>
  );
}

export default ButtonLanding;
